import type { FC } from "react";

import { Inline, Stack } from "@/ui/components/layout";
import { Button } from "@/ui/components/primitives";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import type { TOverviewEditCardProps } from "./OverviewEditCard.config";
import { useOverviewEditCard } from "./useOverviewEditCard";
import {
  OverviewEditCardSkeleton,
} from "./skeletons/OverviewEditCard.skeleton";

export const OverviewEditCard: FC<TOverviewEditCardProps> = ({
  title,
  onEdit,
  isLoading,
  children,
}) => {
  const { editCopy } = useOverviewEditCard();

  if (isLoading) {
    return <OverviewEditCardSkeleton />;
  }

  return (
    <Inline data-component="OverviewEditCard" className="flex-1">
      <Stack gap="2">
        <TextSubtitle size={3} className="max-w-full">
          { title }
        </TextSubtitle>
        <div>
          { children }
        </div>
      </Stack>
      <div>
        <Button icon="pencil" onClick={onEdit} variant="tertiary">
          { editCopy }
        </Button>
      </div>
    </Inline>
  );
};
